import { render } from "./PageYorumlar.vue?vue&type=template&id=6e6d6b30"
import script from "./PageYorumlar.vue?vue&type=script&lang=js"
export * from "./PageYorumlar.vue?vue&type=script&lang=js"
script.render = render

export default script